<template>
	<div>
		<short-header />
		<div>
			<div class="search-header theme-light">
				<div class="panel_header">
					<div id="scroll-on-page-chage" class="container">
						<h1 v-if="taxonomyType !==''">
							Медиа: {{ selectedTaxonomyTypeTitle }}
						</h1>
						<h1 v-else>
							inTrend — новости, статьи, исследования, кейсы
						</h1>
						<search v-model="search" />
						<list-menu
							v-model="taxonomyType"
							:items="taxonomyTypes"
						/>
						<list-menu
							v-model="taxonomySection"
							:items="taxonomySections"
							label-key="media_title"
						/>
					</div>
				</div>
			</div>
			<b-container v-if="$fetchState.pending" class="d-flex justify-content-center mb-3">
				<b-spinner
					style="width: 3em; height: 3em; margin-right: 10px;"
				/>
			</b-container>
			<b-container v-else-if="$fetchState.error">
				{{ $fetchState.error }}
			</b-container>
			<b-container v-else-if="useful && useful.data && useful.data.length === 0">
				<b-alert show class="d-flex justify-content-center mb-3">
					По вашему запросу ничего не найдено
				</b-alert>
			</b-container>
			<template v-else-if="useful">
				<panel-useful-list :list-data="useful.data" />
				<b-pagination
					v-model="page"
					:total-rows="useful.meta.total"
					:per-page="useful.meta.per_page"
					:limit="7"
					align="center"
					pills
					hide-goto-end-buttons
					next-class="pagination-next"
					prev-class="pagination-prev"
					prev-text=""
					next-text=""
				/>
			</template>
			<issue-upcoming-events />
		</div>
		<main-footer />
	</div>
</template>

<script>
import searchMixin from '~/mixins/searchMixin';
import taxonomyMixin from '~/mixins/taxonomyMixin';
import createJivoMixin from '~/mixins/createJivoMixin';

import ShortHeader from '~/components/layouts/headers/ShortHeader.vue';
import MainFooter from '~/components/layouts/footers/MainFooter.vue';
import PanelUsefulList from '~/components/refactor/PanelUsefulList.vue';
import IssueUpcomingEvents from '~/components/blocks/issue/IssueUpcomingEvents.vue';
import Search from '~/components/refactor/Search.vue';

import SlidesMenu from '~/components/refactor/SlidesMenu.vue';
import ListMenu from '~/components/refactor/ListMenu.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
	name: 'SpArticle',
	components: {
		Search,
		SlidesMenu,
		ListMenu,
		ShortHeader,
		MainFooter,
		PanelUsefulList,
		IssueUpcomingEvents,
	},
	mixins: [taxonomyMixin, searchMixin, createJivoMixin()],
	async asyncData({ app, query }) {
		const { $pagesApi } = app;
		const searchValue = query.search || '';

		const [taxonomy] = await Promise.all([
			$pagesApi.usefulContentTaxonomy(),
		]);

		return { taxonomy, searchValue };
	},
	data() {
		return {
			useful: null,
			taxonomy: null,
		};
	},
	// eslint-disable-next-line complexity
	async fetch() {
		const { query } = this.$route;
		const params = {
			per_page: 12,
			category: query.category || '',
			variety: query.variety || '',
			search: query.search || '',
			author_slug: query.author || '',
			content_type: query.content_type || '',
			taxonomy_type: query.taxonomy_type || '',
			taxonomy_project: query.taxonomy_project || '',
			taxonomy_product: query.taxonomy_product || '',
			taxonomy_section: query.taxonomy_section || '',
			taxonomy_topic: query.taxonomy_topic || '',
			page: query.page || 1,
			order_by: 'desc',
		};
		this.useful = await this.$api.contentList(params, { progress: true });
	},
	computed: {
		page: {
			get() {
				return this.$route.query.page || 1;
			},
			set(page) {
				this.$router.push({
					query: {
						...this.$route.query,
						page: page > 1 ? page : undefined,
					},
				});
			},
		},
	},
	watch: {
		'$route.query': {
			async handler() {
				this.$scrollTo('#scroll-on-page-chage');
				this.$fetch();
			},
		},
	},
	created() {
		// this.checkValue();
	},
	methods: {
		...mapActions({
			showLoginPopup: 'authModal/showLogin',
		}),
		...mapMutations({
			// checkAlumni: 'alumni/articleSection',
		}),
		// checkValue() {
		// 	if (this.event.is_alumni === true) {
		// 		this.checkAlumni(true);
		// 	}
		// },
	},
	head() {
		// TODO: fill metadata
		return {
			title: 'Медиа',
			meta: [],
		};
	},
};
</script>

<style style lang="scss" scoped>
	@import "~/assets/styles/components/layouts/event-search-header";
</style>
